import { Icon } from "@iconify/react";

interface ModelIconProps {
  icon: string;
  width?: number;
  height?: number;
  className?: string;
  alt?: string;
  /** Apply dark mode filter to invert dark icons for visibility */
  darkModeInvert?: boolean;
  /** Additional inline styles (useful for portal contexts where CSS classes may not inherit) */
  style?: React.CSSProperties;
}

export function ModelIcon({
  icon,
  width = 20,
  height = 20,
  className = "",
  alt = "",
  darkModeInvert = true,
  style,
}: ModelIconProps) {
  // If icon is a path or filename with image extension, render <img>
  if (
    icon &&
    (icon.endsWith(".svg") ||
      icon.endsWith(".png") ||
      icon.endsWith(".jpg") ||
      icon.endsWith(".jpeg"))
  ) {
    // Apply dark mode invert filter for OpenAI icons (dark icons that need to be visible on dark backgrounds)
    // Uses CSS class from globals.css for reliable cross-browser dark mode support
    const darkModeClass = darkModeInvert ? "model-icon-dark-mode" : "";

    return (
      <img
        alt={alt}
        className={`${className} ${darkModeClass}`.trim()}
        height={height}
        src={icon}
        style={{ display: "inline-block", verticalAlign: "middle", ...style }}
        width={width}
      />
    );
  }

  // Otherwise, assume it's an Iconify icon name
  // Apply dark mode class for consistency with image icons
  const iconClassName = darkModeInvert ? `${className} model-icon-dark-mode`.trim() : className;

  return <Icon className={iconClassName} height={height} icon={icon} style={style} width={width} />;
}
